import { defineCustomElement } from '@tyler-components-web/core';
import { ProductIconComponent } from './product-icon';
export * from './product-icon-adapter';
export * from './product-icon-constants';
export * from './product-icon-foundation';
export * from './product-icon';
export function defineProductIconComponent() {
    defineCustomElement(ProductIconComponent);
}
